import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import LuggageIcon from '@mui/icons-material/Luggage';

const LinkButton = ({ text = '', route, width = '100%' }) => {
  const theme = useTheme();

  return (
    <Box
      id={'link-button'}
      component={RouterLink}
      to={route}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        width,
        height: 42,
        color: theme.tertiary,
        textDecoration: 'none',
        cursor: 'pointer',
        border: '1px solid theme.tertiary',
        padding: '2px',
        borderRadius: '8px',
        '&:hover': {
          bgcolor: alpha(theme.tertiary, 0.1),
        },
      }}
    >
      <LuggageIcon sx={{ fontSize: 30 }} />
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
          color: theme.tertiary,
          fontFamily: theme.typography.fontFamily,
          lineHeight: 1.4,
          userSelect: 'none',
          marginRight: '5px',
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default LinkButton;
